import * as React from 'react';
import type { SVGProps } from 'react';
const SvgComment = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#A5A5AA"
      fillRule="evenodd"
      d="M6.877 9.836a6.025 6.025 0 0 0-.983.277c.275-3.544 3.455-6.415 7.444-6.415 4.175 0 7.464 3.144 7.464 6.915 0 2.243-1.153 4.247-2.964 5.516a.75.75 0 0 0-.314.706l.363 2.937v.001a.176.176 0 0 1-.262.18l-.006-.004-3.897-2.316a.75.75 0 0 0-.316-.102 5.198 5.198 0 0 0 .524-2.276c0-3.103-2.672-5.532-5.866-5.532a6.27 6.27 0 0 0-1.187.113ZM4.381 10.95a8.198 8.198 0 0 1-.007-.337c0-4.695 4.06-8.415 8.964-8.415 4.905 0 8.964 3.72 8.964 8.415 0 2.62-1.272 4.94-3.235 6.472l.309 2.506v.002c.166 1.38-1.32 2.371-2.525 1.645l-.003-.002-3.72-2.21c-.25-.005-.499-.02-.745-.042-1.024 1.064-2.49 1.735-4.107 1.79L6.023 22.11c-.962.584-2.132-.226-2.006-1.297v-.007l.179-1.402c-1.22-1.002-1.998-2.484-1.998-4.15 0-1.755.86-3.303 2.183-4.305Zm1.19.998-.005.004c-1.144.73-1.868 1.944-1.868 3.303 0 1.296.662 2.46 1.724 3.197a.75.75 0 0 1 .316.711l-.188 1.485 2.131-1.266a.75.75 0 0 1 .383-.105c1.417 0 2.662-.619 3.437-1.556l.007-.008.003-.005a3.77 3.77 0 0 0 .92-2.453c0-1.808-1.309-3.389-3.159-3.877a4.674 4.674 0 0 0-1.208-.155c-.35 0-.69.038-1.014.108-.54.119-1.038.33-1.479.617Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgComment;
